export { default } from './DotButton';
